//* NB: Using functions so that i18n doesn't invoke the "t" function immediately
// Not sure if the above comment applies to Remix, but it was initially for React

//* NB: i18n/i18next.t() doesn't work here possibly because of SSR, simplest solution is just to pass

export const getGenderValues = (t: any) => [
  { label: t("male"), value: "male" },
  { label: t("female"), value: "female" },
];

// export const getPaymentMethods = (t: any) => [
//   {
//     label: t("cash"),
//     value: "cash",
//   },
//   {
//     label: "Wave mobile money",
//     value: "wave mobile money",
//   },
//   {
//     label: "MTN mobile money",
//     value: "mtn mobile money",
//   },
//   {
//     label: "Orange mobile money",
//     value: "orange mobile money",
//   },
//   {
//     label: t("other"),
//     value: "other",
//   },
// ];

export const getDoctorAvailabilityValues = (t: any) => {
  return [
    {
      label: t("all"),
      value: "all-time",
    },
    {
      label: t("today"),
      value: "today",
    },
    {
      label: t("this-week"),
      value: "current-week",
    },
    {
      label: t("next-3-days"),
      value: "next-3-days",
    },
    {
      label: t("next-week"),
      value: "next-week",
    },
  ];
};

export const getCountryValues = (t: any, codes: string[], locale: string) => {
  const countries = Array.from(new Set(codes.map(code => code.trim().toUpperCase())))
    .filter(code => /^[A-Z]{2}$/.test(code) && code !== "WW")
    .map(value => ({ value, label: getCountryNameFromCode(value, t, locale) }))
    .sort((a, b) => a.label.localeCompare(b.label, locale));
  return [{ label: t("all-countries"), value: "all" }, ...countries];
};

// Map country ISO codes to full names
export const getCountryNameFromCode = (code: string, t: any, locale: string): string => {
  if (code.toUpperCase() === "WW") return t("worldwide");
  try {
    return new Intl.DisplayNames([locale], { type: "region" }).of(code.toUpperCase()) || code;
  } catch {
    return code;
  }
};
